// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Regular Styles */
html {
    box-sizing: border-box;
}

*,
*:before,
*:after {
    box-sizing: inherit;
}

@font-face {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-stretch: normal;
    src: url(https://fonts.gstatic.com/s/opensans/v34/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4gaVc.ttf) format('truetype');
}

body {
    font-family: "Open Sans", sans-serif;
    color: #4e555f;
    font-size: 14px;
}

/* Bar Delays Animation Function */
/* Chart Styles */
.chart-wrap {
    /* border: 1px solid #eeeeee;
    max-width: 900px;
    margin: 0 auto;
    padding: 10px; */
    margin-top: 7px;
}

.chart-wrap .chart-title {
    margin-bottom: 10px;
    font-size: 16px;
    text-align: center;
    text-transform: uppercase;
}

.chart-wrap .row {
    position: relative;
    height: 26px;
    /* margin-bottom: 15px; */
    /* margin-bottom: 7px; */
    margin: 0px 5px 7px 5px;
}

.chart-wrap .bar-wrap {
    position: relative;
    background: #d7dbde;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.chart-wrap .bar-wrap .bar {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    /* background: #f37167; */
    background: #358696;
    transition: all 1s;
    transform: translateX(-100%);
}

.chart-wrap .bar-wrap .bar.in {
    transform: translateX(0%);
}

.chart-wrap .row:nth-of-type(1) .bar {
    transition: 1s 400ms;
}

.chart-wrap .row:nth-of-type(2) .bar {
    transition: 1s 600ms;
}

.chart-wrap .row:nth-of-type(3) .bar {
    transition: 1s 800ms;
}

.chart-wrap .row:nth-of-type(4) .bar {
    transition: 1s 1000ms;
}

.chart-wrap .row:nth-of-type(5) .bar {
    transition: 1s 1200ms;
}

.chart-wrap .row:nth-of-type(6) .bar {
    transition: 1s 1400ms;
}

.chart-wrap .row:nth-of-type(7) .bar {
    transition: 1s 1600ms;
}

.chart-wrap .label {
    position: absolute;
    top: 0;
    left: 0;
    /* width: 150px; */
    width: 60px;
    padding-left: 10px;
    text-align: left;
    font-size: 12px;
    line-height: 26px;
    text-transform: uppercase;
    font-weight: bold;
    z-index: 10;
}

.chart-wrap .number {
    position: absolute;
    top: 0;
    right: 0;
    padding-right: 5px;
    line-height: 26px;
    font-weight: bold;
    text-align: right;
    z-index: 10;
}

@media screen and (min-width: 800px) {
    .chart-wrap .row {
        /* changed */
        /* padding: 2px 25px 2px 40px; */
        padding: 2px 0px 2px 40px;
        /* changed */
    }

    .chart-wrap .label {
        /* text-align: right; */
        padding-left: 0;
        /* padding-left: 15px; */
    }

    .chart-wrap .number {
        text-align: right;
        /* changed */
        /* padding-right: 0px; */
        padding-right: 5px;
        /* changed */
    }
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/Faultanalysis/FaultFirstPage/Horizantal.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,sBAAsB;AAC1B;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,qIAAqI;AACzI;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,eAAe;AACnB;;AAEA,kCAAkC;AAClC,iBAAiB;AACjB;IACI;;;oBAGgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI;QACI,YAAY;QACZ,gCAAgC;QAChC,yBAAyB;QACzB,YAAY;IAChB;;IAEA;QACI,uBAAuB;QACvB,eAAe;QACf,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;QACjB,YAAY;QACZ,wBAAwB;QACxB,kBAAkB;QAClB,YAAY;IAChB;AACJ","sourcesContent":["/* Regular Styles */\r\nhtml {\r\n    box-sizing: border-box;\r\n}\r\n\r\n*,\r\n*:before,\r\n*:after {\r\n    box-sizing: inherit;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Open Sans';\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-stretch: normal;\r\n    src: url(https://fonts.gstatic.com/s/opensans/v34/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4gaVc.ttf) format('truetype');\r\n}\r\n\r\nbody {\r\n    font-family: \"Open Sans\", sans-serif;\r\n    color: #4e555f;\r\n    font-size: 14px;\r\n}\r\n\r\n/* Bar Delays Animation Function */\r\n/* Chart Styles */\r\n.chart-wrap {\r\n    /* border: 1px solid #eeeeee;\r\n    max-width: 900px;\r\n    margin: 0 auto;\r\n    padding: 10px; */\r\n    margin-top: 7px;\r\n}\r\n\r\n.chart-wrap .chart-title {\r\n    margin-bottom: 10px;\r\n    font-size: 16px;\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.chart-wrap .row {\r\n    position: relative;\r\n    height: 26px;\r\n    /* margin-bottom: 15px; */\r\n    /* margin-bottom: 7px; */\r\n    margin: 0px 5px 7px 5px;\r\n}\r\n\r\n.chart-wrap .bar-wrap {\r\n    position: relative;\r\n    background: #d7dbde;\r\n    width: 100%;\r\n    height: 100%;\r\n    overflow: hidden;\r\n}\r\n\r\n.chart-wrap .bar-wrap .bar {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    height: 100%;\r\n    /* background: #f37167; */\r\n    background: #358696;\r\n    transition: all 1s;\r\n    transform: translateX(-100%);\r\n}\r\n\r\n.chart-wrap .bar-wrap .bar.in {\r\n    transform: translateX(0%);\r\n}\r\n\r\n.chart-wrap .row:nth-of-type(1) .bar {\r\n    transition: 1s 400ms;\r\n}\r\n\r\n.chart-wrap .row:nth-of-type(2) .bar {\r\n    transition: 1s 600ms;\r\n}\r\n\r\n.chart-wrap .row:nth-of-type(3) .bar {\r\n    transition: 1s 800ms;\r\n}\r\n\r\n.chart-wrap .row:nth-of-type(4) .bar {\r\n    transition: 1s 1000ms;\r\n}\r\n\r\n.chart-wrap .row:nth-of-type(5) .bar {\r\n    transition: 1s 1200ms;\r\n}\r\n\r\n.chart-wrap .row:nth-of-type(6) .bar {\r\n    transition: 1s 1400ms;\r\n}\r\n\r\n.chart-wrap .row:nth-of-type(7) .bar {\r\n    transition: 1s 1600ms;\r\n}\r\n\r\n.chart-wrap .label {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    /* width: 150px; */\r\n    width: 60px;\r\n    padding-left: 10px;\r\n    text-align: left;\r\n    font-size: 12px;\r\n    line-height: 26px;\r\n    text-transform: uppercase;\r\n    font-weight: bold;\r\n    z-index: 10;\r\n}\r\n\r\n.chart-wrap .number {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    padding-right: 5px;\r\n    line-height: 26px;\r\n    font-weight: bold;\r\n    text-align: right;\r\n    z-index: 10;\r\n}\r\n\r\n@media screen and (min-width: 800px) {\r\n    .chart-wrap .row {\r\n        /* changed */\r\n        /* padding: 2px 25px 2px 40px; */\r\n        padding: 2px 0px 2px 40px;\r\n        /* changed */\r\n    }\r\n\r\n    .chart-wrap .label {\r\n        /* text-align: right; */\r\n        padding-left: 0;\r\n        /* padding-left: 15px; */\r\n    }\r\n\r\n    .chart-wrap .number {\r\n        text-align: right;\r\n        /* changed */\r\n        /* padding-right: 0px; */\r\n        padding-right: 5px;\r\n        /* changed */\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
